import { render } from "./AlertBar.vue?vue&type=template&id=ecbc5440"
import script from "./AlertBar.vue?vue&type=script&lang=js"
export * from "./AlertBar.vue?vue&type=script&lang=js"

import "./AlertBar.vue?vue&type=style&index=0&id=ecbc5440&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__